export const REFERENCE_TIMEZONE = 'Europe/Paris'
